/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeletePlaceholderAllocationInput = {
    id?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type deletePlaceholderAllocationMutationVariables = {
    input: DeletePlaceholderAllocationInput;
};
export type deletePlaceholderAllocationMutationResponse = {
    readonly deletePlaceholderAllocation: {
        readonly deletedAllocationId: string | null;
    } | null;
};
export type deletePlaceholderAllocationMutation = {
    readonly response: deletePlaceholderAllocationMutationResponse;
    readonly variables: deletePlaceholderAllocationMutationVariables;
};



/*
mutation deletePlaceholderAllocationMutation(
  $input: DeletePlaceholderAllocationInput!
) {
  deletePlaceholderAllocation(input: $input) {
    deletedAllocationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlaceholderAllocationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePlaceholderAllocationPayload",
    "kind": "LinkedField",
    "name": "deletePlaceholderAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAllocationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePlaceholderAllocationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePlaceholderAllocationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deletePlaceholderAllocationMutation",
    "operationKind": "mutation",
    "text": "mutation deletePlaceholderAllocationMutation(\n  $input: DeletePlaceholderAllocationInput!\n) {\n  deletePlaceholderAllocation(input: $input) {\n    deletedAllocationId\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f405f4978fc7be01e5e0ccca2eb35099';
export default node;
